<script>
  import { panelController } from "../../../stores/service";
  import { link } from "svelte-routing";
</script>

{#if $panelController.viewLogin.nav}
<nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="#" role="button"
        ><i class="fas fa-bars" /></a
      >
    </li>
  </ul>
  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">

  </ul>
</nav>
{/if}

